// GET /authorization/permitted-actions/{type} answers
//   { success, data: { resourceType, actions: [...] } }
// and abacApi.getPermittedActions already strips the HTTP layer, so the thunk
// used to store { resourceType, actions } — an object — where callers expect an
// array. Pages that rendered before the login-time capability map arrived then
// crashed on actions.includes(...) (the Tickets page, "ze.includes is not a
// function"). Accept every shape the endpoint has used and always return an array.
export function toPermittedActionList(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];
  if (Array.isArray(payload.actions)) return payload.actions;
  if (payload.data !== undefined) return toPermittedActionList(payload.data);
  return [];
}
